import React from "react"

const Invoice = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.75 1.5a.75.75 0 0 1 .738.615l.012.135V3h3a1.5 1.5 0 0 1 1.49 1.325L21 4.5V21a1.5 1.5 0 0 1-1.325 1.49l-.175.01h-15a1.5 1.5 0 0 1-1.49-1.325L3 21V4.5a1.5 1.5 0 0 1 1.325-1.49L4.5 3h3v-.75a.75.75 0 0 1 .615-.738L8.25 1.5h7.5Zm3.75 3h-15V21h15V4.5Zm-5.086 4.781a.75.75 0 0 1 1.246.825l-.074.113-4 5a.75.75 0 0 1-.42.262l-.146.02H11a.752.752 0 0 1-.44-.144l-.09-.077-2-2a.75.75 0 0 1 .956-1.147l.104.087 1.409 1.407 3.475-4.346Z"
      fill="#80B8EE"
    />
  </svg>
)

export default Invoice;